import React, { useState } from 'react';
import styled from 'styled-components';
import { Button } from 'tdesign-react';
import { ChevronDownIcon } from 'tdesign-icons-react';
import Body from './Body';

export default function Item({
  createTime,
  operateDesc,
  resourceName,
  resourceType,
  username,
  type,
  isFirst,
}) {
  const [open, setOpen] = useState(!!isFirst);
  return (
    <Root>
      <Header onClick={() => setOpen((v) => !v)}>
        <Left>
          <Title>
            [{resourceType}] {operateDesc}
          </Title>
          <Time>{createTime}</Time>
        </Left>
        <Button
          variant='text'
          size='small'
          shape='circle'
          style={{ transform: `rotate(${open ? 180 : 0}deg)` }}
        >
          <ChevronDownIcon />
        </Button>
      </Header>
      {open && (
        <Body
          createTime={createTime}
          operateDesc={operateDesc}
          resourceName={resourceName}
          resourceType={resourceType}
          username={username}
          type={type}
        />
      )}
    </Root>
  );
}

const Root = styled.div`
  margin-bottom: 20px;
`;

const Header = styled.div`
  display: flex;
  cursor: pointer;
`;

const Left = styled.div`
  flex: 1;
  width: 0;
`;

const Time = styled.div`
  color: rgb(143, 149, 159);
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const Title = styled.div`
  color: rgb(13, 17, 26);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
